module.exports = __webpack_public_path__ + "assets/182ded5806d043531f84c919cf3f1a1b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/11/Drop_Bonus5.mp3
 ** module id = 210
 ** module chunks = 0
 **/